import { FC, useState } from 'react';
import { Textarea } from 'src/components/Textarea';
import { Label } from 'src/components/Label';
import { FollowUpCommunicationForm } from 'src/pages/Automations/components/wizard/WizardContext';

interface SmsFieldsProps {
  followUpCall: FollowUpCommunicationForm;
  followUpCallIndex: number;
  onChange: (
    index: number,
    updatedCall: Partial<FollowUpCommunicationForm>,
  ) => void;
}

export const SmsFields: FC<SmsFieldsProps> = ({
  followUpCall,
  followUpCallIndex,
  onChange,
}) => {
  const [isSmsWarning, setIsSmsWarning] = useState(false);

  const handleChange = (field: string, value: string) => {
    onChange(followUpCallIndex, { [field]: value });
    if (field === 'smsBody') setIsSmsWarning(value.length > 160);
  };

  return (
    <>
      <div className="w-full sm:w-full flex-shrink-0">
        <Label htmlFor={`follow-up-sms-body-${followUpCallIndex}`}>
          Message
        </Label>
        <Textarea
          id={`follow-up-sms-body-${followUpCallIndex}`}
          placeholder="Hi {first_name}, this is Sarah from {company_name}. Sorry I missed you..."
          rows={3}
          value={followUpCall.smsBody}
          required
          onChange={(e) => handleChange('smsBody', e.target.value)}
          className="w-full"
        />
        <div className="text-sm text-neutral-400">
          {followUpCall.smsBody?.length || 0} characters
        </div>
        {isSmsWarning && (
          <div className="text-sm text-warning mt-2">
            SMS message is too long. Some providers may cut off the message
            after 160 characters or send it as multiple messages.
          </div>
        )}
      </div>
    </>
  );
};
